import { getData } from './api.service';

/**
 * Obtiene datos para el dashboard principal
 * @param {string} date_from - Fecha desde (YYYY-MM-DD)
 * @param {string} date_to - Fecha hasta (YYYY-MM-DD)
 * @returns {Promise} Datos del dashboard
 */
export const getDashboardData = async (date_from, date_to) => {
  try {
    const response = await getData(
      `/api/reports/dashboard?date_from=${date_from}&date_to=${date_to}`,
      true
    );
    return response?.data;
  } catch (error) {
    console.error('Error obteniendo datos del dashboard:', error);
    throw error;
  }
};

/**
 * Obtiene datos de reportes de ventas en un rango de fechas
 * @param {string} date_from - Fecha desde (YYYY-MM-DD)
 * @param {string} date_to - Fecha hasta (YYYY-MM-DD)
 * @returns {Promise} Datos de reportes
 */
export const getReportsData = async (date_from, date_to) => {
  try {
    const response = await getData(
      `/api/reports/sales?date_from=${date_from}&date_to=${date_to}`,
      true
    );
    return response?.data;
  } catch (error) {
    console.error('Error obteniendo datos de reportes:', error);
    throw error;
  }
};
